
<div class="table-data table-data__custom">
    <table mat-table [dataSource]="dataSource">
        <!-- STT -->
        <ng-container matColumnDef="stt">
            <th mat-header-cell *matHeaderCellDef> {{'BRANCH.TABLE.STT'|translate}} </th>
            <td mat-cell *matCellDef="let element; let i = index">
                {{ i + 1 }}
            </td>
        </ng-container>

        <!-- Dynamic Fields -->
        <ng-container *ngFor="let field of fields" [matColumnDef]="field.key">
            <th mat-header-cell *matHeaderCellDef>
                {{ field.label|translate }}
                <span *ngIf="field.required" style="color:red;">*</span>
            </th>

            <td mat-cell *matCellDef="let element; let i = index" [formGroup]="getRow(i)">

                <!-- Nếu đang edit -->
                <ng-container *ngIf="editMode[i]; else viewMode">
                    <input matInput *ngIf="field.type !== 'date' && field.type !== 'number'" [placeholder]="field.label"
                        [formControlName]="field.key" type="text">

                    <input matInput *ngIf="field.type === 'number'" [placeholder]="field.label"
                        [formControlName]="field.key" type="text" (input)="onInput($event)">

                    <input matInput *ngIf="field.type === 'date'" [placeholder]="field.label" 
                        [formControlName]="field.key" type="date">
                </ng-container>

                <!-- Nếu không edit -->
                <ng-template #viewMode>
                    {{ getRow(i).get(field.key)?.value || '-' }}
                </ng-template>

            </td>
        </ng-container>

        <!-- Hành động -->
        <ng-container matColumnDef="actions">
            <!-- <th mat-header-cell *matHeaderCellDef>
                <button mat-icon-button color="primary" (click)="addRow()">
                    <mat-icon>add</mat-icon>
                </button>
            </th> -->
            <th mat-header-cell *matHeaderCellDef style="width: 105px; text-align: center;">
                <span class="cursor-pointer text-primary" (click)="addRow()">
                    <img class="img__custom-EDIT" src="../../../../assets/images/svgs/add.svg">
                </span>
            </th>
            <td mat-cell *matCellDef="let element; let i = index" class="img__custom-p">

                <!-- Nếu đang edit -->
                <ng-container *ngIf="editMode[i]; else editDeleteButtons">
                    <span class="cursor-pointer text-primary" (click)="onSaveRow(i)">
                        <img class="img__custom-EDIT" src="../../../../assets/images/svgs/check-circle.svg">
                    </span>
                    <span class="cursor-pointer text-danger" (click)="onCancelEdit(i)">
                        <img class="img__custom-Delete" src="../../../../assets/images/svgs/ban.svg">
                    </span>
                </ng-container>

                <!-- Nếu không edit -->
                <ng-template #editDeleteButtons>
                    <span class="cursor-pointer text-primary" (click)="onEditRow(i)">
                        <img class="img__custom-EDIT" src="../../../../assets/images/svgs/mingcute_edit-4-fill.svg">
                    </span>
                    <span class="cursor-pointer text-danger" (click)="removeRow(i)">
                        <img class="img__custom-Delete" src="../../../../assets/images/svgs/wpf_delete.svg">
                    </span>
                </ng-template>

            </td>
        </ng-container>
        <!-- Rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <span class="errorTxt__custom" *ngIf="errorMessage != ''">
        {{ errorMessage }}
    </span>
</div>
